import { Component, Input, OnInit } from '@angular/core';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { QrGeneratorNavigatorEVENT } from 'shared-library';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';

@Component({
  selector: 'app-qrs-event',
  templateUrl: './qrs-event.component.html',
  styleUrls: ['./qrs-event.component.scss', '../qrs-wrapper.component.scss']
})
export class QrsEventComponent implements OnInit {

  @Input() qr_url: string;
  @Input() social_data: SocialHelper;
  @Input() data: QrGeneratorNavigatorEVENT;

  constructor(
    public readonly functionService: FunctionsService
  ) { }

  ngOnInit(): void {
    this.functionService.initializeTooltip()
  }

}
